<template>
  <div ref="modal" class="modal dtf-confirmation-modal" role="dialog">
    <div class="dtf-confirmation-modal__modal-box modal-dialog">
      <div
        class="dtf-confirmation-modal__modal-header"
        role="heading"
        aria-label="Confirm action"
        tabIndex="0"
      >
        <h3 class="dtf-confirmation-modal__modal-title">
          <slot name="header"></slot>
        </h3>

        <button class="dtf-confirmation-modal__modal-button-close" type="button" @click="onClose">
          <UseSvg icon="modal-close-big" />
        </button>
      </div>
      <div class="dtf-confirmation-modal__modal-body">
        <div class="dtf-confirmation-modal__text">
          <slot name="text"></slot>
        </div>

        <div class="dtf-confirmation-modal__actions">
          <button
            v-if="hasSubmit"
            type="button"
            class="dtf-confirmation-modal__submit"
            @click="submit"
          >
            <slot name="button"></slot>
          </button>
          <button type="button" class="dtf-confirmation-modal__cancel" @click="onClose">
            <slot name="cancel"> Cancel </slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initProductSavedCartsSelector from "components/jiffy/product-saved-carts-selector/product-saved-carts-selector";
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "DtfConfirmationModal",
  components: { UseSvg },
  emits: ["submit", "close"],
  data() {
    return {
      closed: false
    };
  },
  computed: {
    hasSubmit() {
      return this.$slots.button;
    }
  },
  mounted() {
    this.onShow();
    initProductSavedCartsSelector(true);
  },
  methods: {
    onShow() {
      const $modal = $(this.$refs.modal);
      $modal.modal("show").on("hidden.bs.modal", () => {
        $modal.off("hidden.bs.modal");
        if (!this.closed) {
          this.$emit("close");
        }
      });
    },
    onClose() {
      $(this.$refs.modal).modal("hide");
      this.closed = true;
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
      $(this.$refs.modal).modal("hide");
      this.closed = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/modal.scss";

.dtf-confirmation-modal {
  @include app-modal;

  &__modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $section-grey;
    border-bottom: 1px solid $gray-border;
  }

  &__modal-title {
    margin: 12px;
  }

  &__modal-body {
    padding-bottom: 16px;
  }

  &__text {
    padding: 24px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
  }

  &__submit {
    width: 100%;
    height: 52px;
    border-radius: 3px;
    font-weight: 700;
    border: 0;
    background-color: $red-light;
    color: $white;
    font-size: 16px;

    &:focus,
    &:hover {
      background-color: $red;
    }
  }

  &__cancel {
    background: $white;
    width: 100%;
    height: 52px;
    border-radius: 3px;
    font-weight: 700;
    color: $primary-light;
    margin-top: 16px;
    border: 1px solid $gray-border;

    &:focus,
    &:hover {
      background-color: $section-grey;
    }
  }
}
</style>
